import { render, staticRenderFns } from "./TrunkManage.vue?vue&type=template&id=3cd8e2e9&"
import script from "./TrunkManage.vue?vue&type=script&lang=js&"
export * from "./TrunkManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports